var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F44336;}\n\t.st1{fill:#FFFFFF;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,254C58.5,254,2,197.5,2,128S58.5,2,128,2s126,56.5,126,126S197.5,254,128,254z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.9,187.1c-3.6,0-7.2-1.4-9.9-4.1c-5.5-5.5-5.5-14.3,0-19.8L163.2,73c5.5-5.5,14.3-5.5,19.8,0 c5.5,5.5,5.5,14.3,0,19.8L92.8,183C90.1,185.7,86.5,187.1,82.9,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.1,187.1c-3.6,0-7.2-1.4-9.9-4.1L73,92.8c-5.5-5.5-5.5-14.3,0-19.8c5.5-5.5,14.3-5.5,19.8,0l90.2,90.2 c5.5,5.5,5.5,14.3,0,19.8C180.3,185.7,176.7,187.1,173.1,187.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.1e7a0a04e5bcbe72db82542c68f33d46.svg";
export { ForwardRef as ReactComponent };